import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { AbstractControl, FormsModule } from "@angular/forms";
import { CustomFormValidators } from "@shared/validators/custom-form-validators";
import { emailValidatorMsg } from '@shared/validators/custom-form-validators-messages';
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { SignGroup } from "@models/annual-statements/annual-statement-enums";
import { SignRow } from "@models/documents/sign-documents";
import { InputComponent } from "@shared/controls/input/input.component";

type ActionEvent = (data: unknown) => void;

type CellRendererParams = ICellRendererParams<SignRow> & {
  edit: ActionEvent,
};

@Component({
  selector: 'app-ag-annual-sign-edit-email',
  standalone: true,
  imports: [
    InputComponent,
    FormsModule
  ],
  templateUrl: 'ag-annual-sign-edit-email.component.html',
  styleUrl: '../styles/ag-hidden-input.scss'
})
export class AgAnnualSignEditEmailComponent implements ICellRendererAngularComp, AfterViewInit {
  protected params!: CellRendererParams;
  public value: string | undefined;
  public disabled = false;
  public validationError = false;
  protected type: SignGroup | undefined;
  protected readonly emailValidatorMsg = emailValidatorMsg;

  @ViewChild('input', { read: ViewContainerRef }) public input!: ViewContainerRef;

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.value = params.data?.email.trim() ?? '';
    this.disabled = params.data?.disabled ?? false;
    this.type = params.data?.type;
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    return true;
  }

  ngAfterViewInit() {
    window.setTimeout(() => {
      if (this.input) {
        (this.input.element.nativeElement as Element).querySelector('input')?.focus();
      }
    });
  }

  onChangeValue(value: string): void {
    if (value === null || value === undefined || value === '') {
      this.params.edit({ value: value ?? '', index: this.params.node.rowIndex, column: 'email' });
      return;
    } else if (this.isEmailValid(value)) {
      this.validationError = false;
      this.params.edit({ value: value, index: this.params.node.rowIndex, column: 'email' });
    } else {
      this.validationError = true;
      this.params.edit({ value: '', index: this.params.node.rowIndex, column: 'email' });
    }

    if (this.params.data) {
      this.params.data.email = value;
    }
  }

  private isEmailValid(email: string): boolean {
    if (!email) return false;

    const control = { value: email } as AbstractControl;
    const errors = CustomFormValidators.emailValidator(control);

    return errors === null;
  }

  onFocus(): void {
    this.params.eGridCell.classList.add('ag-focused-cell');
  }

  onBlur(): void {
    this.params.eGridCell.classList.remove('ag-focused-cell');
  }
}
